import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        // audio元素
        audioelement: '',
        // audio信息
        audio: {
            id: 0,
            name: '',
            singer: '',
            url: '',
            img_url: '',
            type: '',
            lyric: ''
        },
        // 是否显示audio的列表
        showMusicDetail: false,
        // 是否显示歌单列表
        showSongSheet: false,
        // 当前音乐的index索引
        currentIndex: 0,
        // 歌词信息 索引
        lyricIndex: 0,
        // 全部音乐信息  包括歌单等等
        musicAllList: [],
        // 音乐播放信息
        musicList: [],
        // 音乐歌单信息
        musicSheetList: [],
        // 正在播放的音乐歌单类型，到时候区分正在播放的歌曲是存在于哪一个歌单的    默认为-1 表示所有
        musicSheetType: '-1',
        // 图片获取颜色
        songSheetImageColor: '#333',
        // 是否正在播放
        playing: 0,//0 隐藏 1 播放 2 暂停
        // 是否正在加载
        waiting: false,
        // 播放类型   1是自动播放  2是循环播放  3是随机播放
        playType: 1,
        // 当前播放的时间
        currentTime: 0,
        // 音乐的播放时长
        musicDuration: 0,
        // 音乐是否在加载
        musicLoadStart: false,
    //    详情列表的播放状态
        palyorpause:[
            // {state:true},
            // {state:true},
            // {state:true},
            // {state:true}
        ],
        isType:0,// 0代表浏览器 1代表微信 2代表andriod 3代表ipone
    //    详情页的所有数据
        dataBox:[],
        //提示消息
        message:"",
    //    showType
        showType:false,
        userId:0,
        // mp3Url:`http://oml9jrsxm.bkt.clouddn.com/`,
        mp3Url:`//file.120xinmao.com/`,
        info:'111',
        info2:'11111111111111111111',
        token:'11111111111111111111',
        loginType:'',
        companyLogo:'',
    },
    getters: {
        // 获取audio元素
        getAudioElement: state => state.audioelement,
        // 获取audio信息
        getAudioInfo: state => state.audio,
        // 获取当前播放的索引
        getCurrentIndex: state => state.currentIndex,
        // 获取音乐播放列表信息
        getMusicList: state => state.musicList,
        getDataBox: state => state.dataBox,
        // 获取音乐全部信息
        getMusicAllList: state => state.musicAllList,
        // 获取音乐是否播放
        getIsPlaying: state => state.playing,
        // 获取音乐是否加载
        getIsWaiting: state => state.waiting,
        // 获取音乐是否打开底部音乐列表
        getMusicDetail: state => state.showMusicDetail,
        // 当前音乐详细信息
        getCurrentMusic: state => state.musicList[state.currentIndex],
        // 获取播放类型
        getMusicPlayType: state => state.playType,
        // 获取当前的播放进度
        getCurrentTime: state => state.currentTime,
        // 获取音乐的播放时长
        getMusicDuration: state => state.musicDuration,
        // 音乐开始加载
        getIsLoadStart: state => state.musicLoadStart,
        // 获取歌单列表的显示状态
        getIsShowSongSheet: state => state.showSongSheet,
        // 获取歌单信息
        getMusicSheetList: state => state.musicSheetList,
        // 获取歌单图片颜色
        getSongSheetImageColor: state => state.songSheetImageColor,
        // 获取音乐歌单类型
        getMusiSheetType: state => state.musicSheetType,
        // 获取音乐歌词当前播放的索引
        getLyricIndex: state => state.lyricIndex
    },
    mutations: {
        setInfo(state, value) {
            state.info = value
        },
        setInfo2(state, value) {
            state.info2 = value
        },
        setLoginType(state, value) {
            state.loginType = value
        },
        setCompanyLogo(state, value) {
            state.companyLogo = value
        },
        // play设置
        play (state) {
            state.playing = 1;
            state.audioelement.play()
        },
        // 暂停设置
        pause (state) {
            state.playing = 2;
            state.audioelement.pause()
        },
        togglePlay (state) {
            if (state.playing==1) {
                state.playing = 2;
                state.audioelement.pause()
                state.palyorpause.forEach(function (v,i) {
                    v.state=true;
                })
            } else if(state.playing==2){
                state.playing = 1;
                state.audioelement.play()
                state.palyorpause.forEach(function (v,i) {
                    v.state=true;
                })
                state.palyorpause[state.currentIndex].state=false;
            }
        },
        // 开关显示底部列表
        toggerMusicDetail (state) {
            state.showMusicDetail = !state.showMusicDetail
        },
        // 初始化音乐
        initAudio (state) {
            if (state.musicList) {
                alert(1)
            } else {
                alert(2)
            }
        },
        // 插入播放列表信息
        setMusicList (state, obj) {
            state.musicList = obj
        },
        setData (state, obj) {
            state.dataBox = obj
        },
        // 插入所有音乐信息
        setMusicAllList (state, obj) {
            state.musicAllList = obj
            state.musicList = obj.all
        },
        // 获取音乐元素 Dom
        setAudioElement (state, ele) {
            state.audioelement = ele
        },
        // 关闭底部列表
        setMusicDetail (state, obj) {
            state.showMusicDetail = obj.isShow
        },
        setPlayType (state) {
            if (state.playType === 3) {
                state.playType = 1
            } else {
                state.playType ++
            }
        },
        // 播放下一曲
        playNext (state) {
                   state.palyorpause.forEach(function (v,i) {
                       v.state=true;
                   })
                   state.palyorpause[state.currentIndex].state=false;
                state.audioelement.setAttribute('src', state.mp3Url+state.musicList[state.currentIndex].audioPath)
                state.playing = 1;
                state.audioelement.load()
                state.audioelement.play()
        },
        // 播放上一曲
        playPrev (state) {
                state.palyorpause.forEach(function (v,i) {
                    v.state=true;
                })
                state.palyorpause[state.currentIndex].state=false;
                state.audioelement.setAttribute('src', state.mp3Url+state.musicList[state.currentIndex].audioPath)
                state.playing = 1;
                state.audioelement.load()
                state.audioelement.play()

        },

        // 设置当前的播放索引
        playIndex (state, obj) {
            state.currentIndex = obj.index
            state.audioelement.setAttribute('src', state.mp3Url+state.musicList[state.currentIndex].audioPath)
            state.playing = 1;
            state.audioelement.load()
            state.audioelement.play()
        },

        // 设置音乐结束自动播放播放类型的歌曲
        playEnded (state) {
            // state.currentIndex ++
            // const length = state.musicList.length
            // if (state.currentIndex >= length) {
            //     state.currentIndex --;
            //     state.message="已经是最后一节";
            //     state.showType=true;
            //     setTimeout(function () {
            //         state.showType=false;
            //     },500)
            //     // state.currentIndex = 0
            // }else{
                state.palyorpause.forEach(function (v,i) {
                    v.state=true;
                })
                state.palyorpause[state.currentIndex].state=false;
                state.audioelement.setAttribute('src',state.mp3Url+state.musicList[state.currentIndex].audioPath)
                state.playing = 1;
                state.audioelement.load()
                state.audioelement.play()
            // }
        },
        setCurrentTime (state, obj) {
            state.currentTime = obj.time
        },
        setMusicDuration (state, obj) {
            state.musicDuration = obj.duration
        },
        // 设置音乐是否正在加载
        setMusicLoadStart (state, obj) {
            state.musicLoadStart = obj.isloadstart
        },
        // 设置是否显示歌单信息
        setIsShowSongSheet (state, obj) {
            state.showSongSheet = obj.isShow
        },
        // 设置音乐播放器的歌单列表数据
        setMusicSheetList (state, obj) {
            state.musicSheetList = obj.data
        },
        setSongSheetImageColor (state, obj) {
            state.songSheetImageColor = obj.color
        },
        // 设置音乐歌单类型
        setMusiSheetType (state, obj) {
            state.musicSheetType = obj.sheettype
        },
        // 设置音乐歌词当前播放的索引
        setLyricIndex (state, obj) {
            state.lyricIndex = obj.index
        }
    },
    actions: {
        set_AudioElement ({commit}, ele) {
            commit('setAudioElement', ele)
        },
        set_MusicDetail ({commit}, obj) {
            commit('setMusicDetail', obj)
        },
        set_MusicAllList ({commit}, obj) {
            commit('setMusicAllList', obj)
        },
        set_MusicList ({commit}, obj) {
            commit('setMusicList', obj)
        },
        set_Data ({commit}, obj) {
            commit('setData', obj)
        },
        set_PlayType ({commit}) {
            commit('setPlayType')
        },
        set_CurrentTime ({commit}, obj) {
            commit('setCurrentTime', obj)
        },
        set_MusicDuration ({commit}, obj) {
            commit('setMusicDuration', obj)
        },
        set_MusicSheetList ({commit}, obj) {
            commit('setMusicSheetList', obj)
        },
        set_SongSheetImageColor ({commit}, obj) {
            commit('setSongSheetImageColor', obj)
        },
        play_Next ({commit}) {
            commit('playNext')
        },
        play_Prev ({commit}) {
            commit('playPrev')
        },
        play_Index ({commit}, obj) {
            commit('playIndex', obj)
        },
        play_Ended ({commit}) {
            commit('playEnded')
        }
    },
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js